angular.module('shared').directive('calendarFilter', ["$window", function($window) {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      var adjustDropdownMenuHeight, dropdownMenu, dropdownToggle;
      dropdownToggle = element[0].querySelector('.dropdown-toggle');
      dropdownMenu = element[0].querySelector('.dropdown-menu');
      adjustDropdownMenuHeight = function() {
        var dropdownMenuHeight, dropdownMenuRect, dropdownToggleHeight, dropdownToggleRect, windowHeight;
        dropdownToggleRect = dropdownToggle.getBoundingClientRect();
        dropdownMenuRect = dropdownMenu.getBoundingClientRect();
        dropdownToggleHeight = dropdownToggleRect.bottom - dropdownToggleRect.top;
        windowHeight = $window.innerHeight;
        dropdownMenuHeight = windowHeight - dropdownToggleHeight - dropdownToggleRect.top;
        return dropdownMenu.style.maxHeight = dropdownMenuHeight + 'px';
      };
      dropdownToggle.addEventListener('click', adjustDropdownMenuHeight);
      return scope.$on('$destroy', function() {
        return dropdownToggle.removeEventListener('click', adjustDropdownMenuHeight);
      });
    }
  };
}]);
